module.exports = __webpack_public_path__ + "static/media/sculptureP.84ed9684.jpg";